var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgMessageRead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.105 14.203l7.336-6L12 .824 1.582 8.204l7.371 6.023zm-5.835.75l-6.961 8.223h19.406L14.695 15zm6.257-.098l6.973 8.313V8.953zM1.5 8.953v14.215l6.973-8.313zm0 0",
    fill: "#acacac"
  })));
}

export default SvgKpmgMessageRead;